import React from "react";

function Popup({ selected, closePopup }) {
  return (
    <section className="popup ">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 mt-3">
            <div class="card popcard">
              <div class="card-horizontal">
                <div class="img-square-wrapper d-xs-none d-sm-none d-md-block">
                  <img class="" src={selected.recipe.image}></img>
                </div>
                <div class="card-body popup-body">
                  <div className=" card-header">
                    <h6 className="text-light card-title">
                      {selected.recipe.label}
                    </h6>
                    <ul className="list-group list-group-horizontal">
                      <li className="list-group-item">
                        SERVES{" "}
                        <span className="res">{selected.recipe.yield}</span>
                      </li>
                      <li className="list-group-item">
                        TIME{" "}
                        <span className="res">
                          {Math.floor(selected.recipe.totalTime)} MINS
                        </span>
                      </li>
                      <li className="list-group-item">
                        DISH{" "}
                        <span className="res">{selected.recipe.dishType}</span>{" "}
                      </li>
                      <li className="list-group-item">
                        SOURCE{" "}
                        <span className="res">
                          <a
                            href={selected.recipe.url}
                            data-toggle="tooltip"
                            data-placement="top"
                            title={selected.recipe.source}
                          >
                            <i class="fas fa-globe"></i>
                          </a>
                        </span>{" "}
                      </li>
                    </ul>
                  </div>
                  <div className="container">
                    <h6>STEPS</h6>
                    <ul className="list-group list-group-flush">
                      {selected.recipe.ingredients.map((ingredient) => (
                        <li className="list-group-item text-dark">
                          {ingredient.text}
                        </li>
                      ))}
                    </ul>
                    <a
                      href="#"
                      onClick={closePopup}
                      className="btn close col-sm-12 col-md-6"
                    >
                      Close
                    </a>
                  </div>

                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Popup;
